import React from 'react';
import PropTypes from 'prop-types';
import ModuleBlock from '../ModuleBlock';
import ModuleService from '../../../../../services/module';
import { List, ListItem } from 'material-ui/List';
import styles from '../FirebaseModuleBlock/FirebaseModuleBlock.css';
import Error from 'material-ui/svg-icons/alert/error';
import { white } from 'material-ui/styles/colors';
import withTranslation from '../../../../../hoc/withTranslation';

class PushModuleBlock extends React.Component {
    static propTypes = {
        app: PropTypes.object.isRequired,
    };

    render() {
        let content = null;

        const isConfigOK =
            this.props.app.configurations.push_server_id !== null
            && this.props.app.configurations.push_server_key !== null
            && this.props.app.configurations.push_server_token_dev !== null
            && this.props.app.configurations.push_server_token_prod !== null;

        if (!isConfigOK) {
            content = <List>
                <ListItem
                    style={styles.list}
                    disabled={true}
                    primaryText={this.props.t('module.push.configuration_ko')}
                    leftIcon={<Error color={white} />} />
            </List>;
        }
        return (
            <ModuleBlock app={this.props.app} module={ModuleService.getModule(ModuleService.PUSH)}
                         content={content} />
        );
    }
}

export default withTranslation(PushModuleBlock);



// WEBPACK FOOTER //
// src/components/application/ApplicationFull/ModuleBlock/PushModuleBlock/PushModuleBlock.js